import {
    Component,
    inject
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "mgd-admin",
    templateUrl: "./app.component.html",
    imports: [RouterOutlet]
})

export class AppComponent {

    private readonly _matIconRegistry = inject(MatIconRegistry);
    constructor() {

        this._matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
    }
}
